import script from "./NewsletterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterPage.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterPage.vue?vue&type=style&index=0&id=55fb96a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55fb96a8"]])

export default __exports__